export default __webpack_public_path__ + "static/O0082-709d42813942fff482c049eef86e9d2b.png";